<template>
  <div class="formGroup operadorSearch" style="padding: 20px">    
    <label for="operador">Operador</label>
    <div class="searchWrapper">
      <input
        placeholder="Buscar operador..."
        type="text"
        id="operador"
        v-model="searchQuery"
        @input="filterOperators"
        @keydown.enter="selectFirstOperator"
        @focus="showSelect = true"
        class="upper-case"
      />

      <div
        v-if="showSelect && filteredOperators.length > 0"
        class="operatorDropdown"
      >
        <div
          v-for="operator in filteredOperators"
          :key="operator.operator"
          class="operatorItem"
          @click="selectOperator(operator.operator)"
        >
          {{ operator.operator }}
        </div>
      </div>

    </div>

  </div>
</template>
<script>
import IberoHelpers from '@/store/helpers.js'

export default {
  data () {
    return {
      operador: '', // Operador seleccionado
      searchQuery: '', // Texto ingresado en el input
      operators: [], // Lista completa de operadores
      filteredOperators: [], // Lista filtrada según el texto ingresado
      showSelect: false, // Controla la visibilidad del select
    }
  },
  mounted () {
    // Cargar los operadores al montar el componente
    IberoHelpers.GetOperatorList(this.$store)
      .then((response) => {
        this.operators = response.data // Asigna la respuesta del servicio
        this.filteredOperators = this.operators // Inicializa la lista filtrada
      })
      .catch((error) => {
        console.error('Error loading data:', error)
      })
  },
  methods: {
    emitOperador () {
      // Emitir el operador seleccionado al componente padre
      this.$emit('update-operator-text', this.operador)
      this.hideSelect()
    },
    filterOperators () {
      // Filtrar la lista de operadores según el texto ingresado
      const query = this.searchQuery.toLowerCase()
      this.filteredOperators = this.operators.filter((operator) =>
        operator.operator.toLowerCase().includes(query)
      )

      // Mostrar el select si hay resultados y el usuario interactúa
      this.showSelect = this.filteredOperators.length > 0
      // Emitir cambios en vivo
      this.$emit('update-operator-text', this.searchQuery.toUpperCase())
    },
    selectOperator (operator) {
      // Asignar el operador seleccionado y emitir el cambio
      this.operador = operator
      this.searchQuery = operator
      this.emitOperador()
    },
    selectFirstOperator () {
      // Selecciona el primer operador al presionar Enter
      if (this.filteredOperators.length > 0) {
        this.selectOperator(this.filteredOperators[0].operator)
      }
    },
    hideSelect () {
      // Esconde el select al perder el foco
      setTimeout(() => {
        this.showSelect = false
      }, 200) // Se agrega un pequeño retraso para que se registre el evento de selección
    },
  },
}
</script>